
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/en-gb/pricing",
      function () {
        return require("private-next-pages/en-gb/pricing.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/en-gb/pricing"])
      });
    }
  